/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export default function PositionedMenu({
    anchorEl,
    onClose,
    menuItems = [],
    onItemClick,
    anchorOrigin = { vertical: "top", horizontal: "left" },
    transformOrigin = { vertical: "top", horizontal: "left" },
    MenuListProps = {}, 
}) {
    const open = Boolean(anchorEl);

    const handleClose = (item) => {
        if (onItemClick && item) {
            onItemClick(item);
        }
        onClose(); // close menu from parent
    };

    return (
        <Menu
            id="positioned-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            MenuListProps={MenuListProps} // apply passed MenuListProps
            sx={{ zIndex: 1400 }}
        >
            {menuItems.map((item, index) => (
                <MenuItem key={index} onClick={() => handleClose(item)}>
                    {item}
                </MenuItem>
            ))}
        </Menu>
    );
}
